import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import '../buzon/buzon.css';

/*
 * Pantalla de "Se registró tu respuesta" y el diálogo del enlace precompletado.
 */

export function Confirmacion({ titulo, resultado, ajustes, vistaPrevia, onOtra, onIr }) {
  const mensaje = resultado?.mensaje || ajustes?.mensaje_confirmacion || 'Se registró tu respuesta.';
  const p = resultado?.puntuacion;
  const conPuntos = p && p.total !== undefined && p.total !== null;
  return (
    <div className="fm-tarjeta fm-tarjeta-encabezado fr-confirmacion">
      <h1 className="fm-titulo-form">{titulo || 'Formulario'}</h1>
      <p className="fr-confirmacion-mensaje">{mensaje}</p>
      {vistaPrevia && (
        <p className="fm-texto-2">Esto es una vista previa: la respuesta no se guardó.</p>
      )}
      {resultado?.caso?.folio && (
        // Buzón de casos: el folio y el enlace para seguirlo (ver components/forms/buzon/SeguimientoCaso.jsx)
        <div className="bz-confirmacion">
          <span className="bz-seg-rotulo">Tu folio</span>
          <span className="bz-seg-folio">{resultado.caso.folio}</span>
          {resultado.caso.seguimiento_url && (
            <>
              <p className="fm-texto-2 text-[13px]">Con este enlace puedes ver en qué va tu caso y escribirnos de nuevo. Guárdalo.</p>
              <div className="flex flex-wrap gap-2">
                <button type="button" className="fm-boton" onClick={() => onIr(resultado.caso.seguimiento_url)}>Ver el seguimiento</button>
                <BotonCopiar texto={`${window.location.origin}${resultado.caso.seguimiento_url}`} />
              </div>
            </>
          )}
        </div>
      )}
      {conPuntos && (
        <div className="fr-puntuacion-total is-compacta">
          <span className="fr-puntuacion-cifra">{p.total}</span>
          <span className="fr-puntuacion-de">/{p.maximo}</span>
          <span className="fr-puntuacion-rotulo">Tu puntuación</span>
        </div>
      )}
      <div className="fr-confirmacion-enlaces">
        {(ajustes?.enlace_otra_respuesta ?? true) && (
          <button type="button" className="fm-boton-texto" onClick={onOtra}>Enviar otra respuesta</button>
        )}
        {resultado?.editar_url && (
          <button type="button" className="fm-boton-texto" onClick={() => onIr(resultado.editar_url)}>Editar tu respuesta</button>
        )}
        {resultado?.calificacion_url && (
          <button type="button" className="fm-boton-texto" onClick={() => onIr(resultado.calificacion_url)}>Ver puntuación</button>
        )}
        {resultado?.resumen && (
          // `resumen` puede llegar como bool o como la URL ya hecha
          <button
            type="button"
            className="fm-boton-texto"
            onClick={() => onIr(typeof resultado.resumen === 'string' ? resultado.resumen : '?resumen=1')}
          >
            Ver resumen de respuestas
          </button>
        )}
      </div>
    </div>
  );
}

function BotonCopiar({ texto }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(texto);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      window.prompt('Copia el enlace:', texto);
    }
  };
  return (
    <button type="button" className="fm-boton-borde" onClick={copiar}>
      {copiado ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} {copiado ? 'Copiado' : 'Copiar enlace'}
    </button>
  );
}

export function DialogoEnlacePrecompletado({ abierto, onCerrar, enlace, sinToken }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = async () => {
    try {
      await navigator.clipboard.writeText(enlace);
      setCopiado(true);
      toast.success('Enlace copiado');
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      window.prompt('Copia el enlace:', enlace);
    }
  };
  return (
    <Dialog open={abierto} onOpenChange={(v) => !v && onCerrar()}>
      <DialogContent className="sm:max-w-[520px] fr-dialogo">
        <DialogHeader>
          <DialogTitle>Enlace precompletado</DialogTitle>
          <DialogDescription>
            {sinToken
              ? 'Publica el formulario para obtener enlaces precompletados.'
              : 'Quien abra este enlace verá el formulario con estas respuestas ya puestas; puede cambiarlas antes de enviar.'}
          </DialogDescription>
        </DialogHeader>
        {!sinToken && (
          <div className="flex items-center gap-2">
            <Input readOnly value={enlace} className="rounded-xl text-xs font-mono" onFocus={(e) => e.target.select()} aria-label="Enlace precompletado" />
            <Button variant="outline" size="icon" onClick={copiar} aria-label="Copiar enlace">
              {copiado ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
            </Button>
          </div>
        )}
        <DialogFooter>
          {!sinToken && <Button onClick={copiar}>Copiar enlace</Button>}
          <Button variant="outline" onClick={onCerrar}>Cerrar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
